import React, { useState, useEffect} from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { MessageBar, MessageBarType, PrimaryButton, Icon } from '@fluentui/react';
import { mapDbUserForPeoplePicker } from '../formFields/PeoplePicker';
import Api from '../../services/Api'
import MasterDataManagersItem from './MasterDataManagersItem';

const BaServiceLeads = ({depth = 1, keyProperty = 'key'}) => {
    
    const [isLoading, setLoading] = useState(false);
    const [allMasterData, setAllMasterData] = useState({});
    const [masterData, setMasterData] = useState([]);
    const [serviceLeads, setServiceLeads] = useState({});
    const [systemAdmins, setSystemAdmins] = useState({});
    const [message, setMessage] = useState();
    const [isSaving, setSaving] = useState(false);
    const [showGroup, setShowGroup] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            await getManagers();
        }
        fetchData();
    }, []);

    const getManagers = async () => {
        setLoading(true);
        try {
            const res = await Api.get('/Settings/ManagementManagers');
            const data = res.data;

            const masterData = depth ? data.filter(x => x.depth === depth) : data;

            const serviceLeadsUser = data.reduce((acc, t) => {
                return t.serviceLeads.length === 0 ? {...acc} : {
                    ...acc,
                    [t.id]: t.serviceLeads.map(u => mapDbUserForPeoplePicker(u))
                }
            }, []);

            const systemAdminsUsers = data.reduce((acc, t) => {
                return t.systemAdmins.length === 0 ? {...acc} : {
                    ...acc,
                    [t.id]: t.systemAdmins.map(u => mapDbUserForPeoplePicker(u))
                }
            }, []);

            setAllMasterData(data.reduce((accumulator, currentValue) => { return {...accumulator, [currentValue[keyProperty]]: currentValue}}, {}));
            setMasterData(masterData);
            setServiceLeads(serviceLeadsUser);
            setSystemAdmins(systemAdminsUsers)

            setLoading(false);
        }
        catch(error) {
            setMessage({
                type: MessageBarType.error,
                text: 'Cannot get Managers settings from database: ' + error
            });
        }
    }

    const save = async (endpoint, data) =>
    {
        try {
            const res = await Api.post(endpoint, data);
            const post = res.status;

            if(post === 200) {
                
            } else {
                setSaving(false);
                setMessage({
                    type: MessageBarType.error,
                    text: 'Cannot save settings: ' + post.message
                });
            }
        } catch(error) {
            setSaving(false);
            console.log(error);
        };
    }

    const saveSettings = async () => {
        setSaving(true);
        setMessage();
        
        await Promise.all([save('/Settings/BaServiceLeads', serviceLeads), save('/Settings/SystemAdmins', systemAdmins)])

        setSaving(false);
        setMessage({
            type: MessageBarType.success,
            text: 'Settings have been saved.'
        });
    }

    const onSelectedServiceLeads = (id, newUsers) => {
        const u = {
            ...serviceLeads,
            [id]: newUsers
        }
        setServiceLeads(u);
    }

    const onSelectedSystemAdmins = (id, newUsers) => {
        const u = {
            ...systemAdmins,
            [id]: newUsers
        }
        setSystemAdmins(u);
    }

    const msg = message && 
                <MessageBar messageBarType={message.type}>
                    {message.text}
                </MessageBar>

    const onHeaderNameRender = (management) => `${management.value} (${management.key})`

    const items = masterData.sort().map((x, index) => 
        {
            const key = x[keyProperty]
            return <div key={index} style={containerStyles}>
                    <div style={headerStyles} onClick={() => setShowGroup({...showGroup, [key]: !showGroup[key]})}>
                        <Icon iconName={showGroup[key] ? 'ChevronUp' : 'ChevronDown'} style={iconStyles}/> 
                        {onHeaderNameRender(allMasterData[key])}
                    </div>
                    {
                        showGroup[key] &&
                        <div style={itemsStyles}>
                            <MasterDataManagersItem
                                name={'Service Leads'} 
                                managers={x.serviceLeads}
                                onSelectedUsers={(users) => onSelectedServiceLeads(x.id, users)} 
                                includeGroups={false}
                            />
                            <MasterDataManagersItem
                                name={'System Admins'} 
                                managers={x.systemAdmins}
                                onSelectedUsers={(users) => onSelectedSystemAdmins(x.id, users)} 
                            />
                        </div>
                    }
                </div>
        }
    )
    
    const btn = isSaving
                ? <Spinner className='settings-btn' size={SpinnerSize.large} />
                : <PrimaryButton className='settings-btn' onClick={saveSettings}>Save</PrimaryButton>

    return (
        <div>
            {isLoading
                ? <Spinner style={{margin: '200px'}} size={SpinnerSize.large} />
                :  
                <div className='settings-container'>
                    {items}
                    {btn}
                    {msg}
                </div>
            }
        </div>
    );
}
const iconStyles = {
    verticalAlign: 'middle',
    marginRight: 10
}

const containerStyles = {
    margin: '0 20px 20px 10px',
}

const headerStyles = {
    fontSize: 18,
    cursor: 'pointer'

}
const itemsStyles = {
    margin: '20px 0 0 29px',
}


export default BaServiceLeads;



// WEBPACK FOOTER //
// ./src/components/Settings/BaServiceLeads.js